import { useEffect, useState } from "react";
import { visuallyHidden } from "@mui/utils";
import { Chip, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "utils/locales/utilityFunctions";

export default function CopyAudienceLink({ url }: { url: string }) {
  const { translate } = useTranslation();
  const [status, setStatus] = useState<"copied" | "failed" | null>(null);

  useEffect(() => {
    if (status !== "copied") return;
    const timer = window.setTimeout(() => setStatus(null), 2000);
    return () => window.clearTimeout(timer);
  }, [status]);

  const copy = async () => {
    setStatus(null);
    try {
      await navigator.clipboard.writeText(url);
      setStatus("copied");
    } catch {
      setStatus("failed");
    }
  };

  return <>
    <Tooltip title={translate("subscription-org-to-org-key-copy-tooltip")}>
      <Chip component="button" type="button" size="small" onClick={copy}
        color={status === "copied" ? "primary" : "secondary"}
        variant={status === "copied" ? "filled" : "combined"}
        label={status === "copied" ? translate("subscription-org-to-org-key-copied") : url}
        aria-label={`${translate("subscription-org-to-org-key-copy-tooltip")}: ${url}`}
        sx={{ maxWidth: "100%", height: "auto", minHeight: 24, alignSelf: "flex-start", textAlign: "left",
          "& .MuiChip-label": { whiteSpace: "normal", overflowWrap: "anywhere", py: 0.5 } }} />
    </Tooltip>
    <Typography variant="caption" color={status === "failed" ? "error" : "text.secondary"} role="status" sx={status === "copied" ? visuallyHidden : undefined}>
      {status && translate(status === "copied" ? "subscription-org-to-org-key-copied" : "share-audience-copy-failed")}
    </Typography>
  </>;
}
